'use client';

import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import classNames from 'classnames';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { Button } from '@get-mosh/msh-shared';
import Heading from 'src/components/Heading/Heading';

import styles from './image-content.module.scss';

import type { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
export type ImageContentProps = SliceComponentProps<Content.ImageContentSlice>;

const ImageContent = ({
    slice,
    context,
}: ImageContentProps & { context: { pageType: string } }) => (
    <section
        style={{ backgroundColor: slice.primary.content_background || 'white' }}
    >
        <div
            id={slice.primary.heading || ''}
            className={classNames(
                styles['image-content__container'],
                slice.primary.image_mobile === 'top'
                    ? 'flex-col'
                    : 'flex-col-reverse',
                slice.primary.image_desktop === 'left'
                    ? 'md:flex-row'
                    : 'md:flex-row-reverse',
            )}
        >
            {slice.primary.image?.url && (
                <div className={styles['image-content__img']}>
                    <PrismicNextImage field={slice.primary.image} fill />
                </div>
            )}
            <div className={styles['image-content__content']}>
                <Heading level={'h2'} tag="h" className="mb-2">
                    {slice.primary.heading}
                </Heading>

                {slice.primary.text_content && (
                    <PrismicRichText field={slice.primary.text_content} />
                )}

                {slice.primary.cta && slice.primary.path && (
                    <Button
                        text={slice.primary.cta}
                        as="a"
                        href={slice.primary.path}
                        onClick={() => {
                            trackClick(EventNames.BUTTON_CLICKED, {
                                pageType: context.pageType,
                                label: slice.primary.cta || '',
                                link: slice.primary.path || '',
                                variation: slice.variation,
                                location: slice.slice_type,
                            });
                        }}
                    />
                )}
            </div>
        </div>
    </section>
);

export default ImageContent;
